export const findKeyByValue = (obj: any, value: string | number) => {
  const keys = Object.keys(obj);
  const foundKey = keys.find((key) => obj[key] === value);
  return foundKey || null;
};
